import { ContentHeaderButton } from "../../contentHeaderButton";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { IndorImages, getIndorImageSrc } from "../../../../features";
import { controlDiagnosticsMeasureResultsFilterButton, controlShowTableCSVExportWindowButton, controlShowTableEXCELExportWindowButton, controlShowTableInfoWindowButton, controlShowTablePDFExportWindowButton } from "./widgetsFunctions";
import { useEffect, useState } from "react";

const showTablePDFExportWindowButtonIconSrc = require('../../../../assets/images/icons/pdf_export_icon.svg').default
const showTableCSVExportWindowButtonIconSrc = require('../../../../assets/images/icons/csv_export_icon.svg').default
const dateFilterButtonIconSrc = require('../../../../assets/images/icons/date_filter_icon.svg').default

const showTableInfoWindowButtonIconSrc = getIndorImageSrc(IndorImages.MessageInfo);
const showTableEXCELExportWindowButtonIconSrc = getIndorImageSrc(IndorImages.ExcelExport);

export default function ContentHeaderTableWidgets({ tableType }: any) {
    const navigate = useNavigate()
    const [windowIsSmall, setWindowIsSmall] = useState(false);
    const { tableInfoWindowIsShown, tablePDFExportWindowIsShown, tableCSVExportWindowIsShown, tableEXCELExportWindowIsShown } = useAppSelector(state => state.contentHeader)
    const sideBarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        if (tableType === 'diagnosticsMeasureResults') {
            setWindowIsSmall(contentHeaderWidth < 1080)
        }
    }, [sideBarIsShown, navigate])

    const diagnosticsMeasureResultsFilterButtonIsVisible = tableType === "diagnosticsMeasureResults" && windowIsSmall

    const widgetsConfigArray = [
        {
            active: tableInfoWindowIsShown,
            name: "Информация о таблице",
            imageSrc: showTableInfoWindowButtonIconSrc,
            onClick: controlShowTableInfoWindowButton
        },
        {
            active: tablePDFExportWindowIsShown,
            name: "Экспорт в PDF",
            imageSrc: showTablePDFExportWindowButtonIconSrc,
            onClick: controlShowTablePDFExportWindowButton
        },
        {
            active: tableCSVExportWindowIsShown,
            name: "Экспорт в CSV",
            imageSrc: showTableCSVExportWindowButtonIconSrc,
            onClick: controlShowTableCSVExportWindowButton
        },
        {
            active: tableEXCELExportWindowIsShown,
            name: "Экспорт в EXCEL",
            imageSrc: showTableEXCELExportWindowButtonIconSrc,
            onClick: controlShowTableEXCELExportWindowButton
        },
        {
            visible: diagnosticsMeasureResultsFilterButtonIsVisible,
            name: "Настройки фильтров результатов измерений",
            imageSrc: dateFilterButtonIconSrc,
            onClick: () => controlDiagnosticsMeasureResultsFilterButton(navigate)
        }
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                const { visible, name, active, imageSrc, onClick, loading } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                            isLoading={loading}
                        />
                    )
                }
            })}
        </>
    )
}